<template>
	<div class="form-row" v-if="group" :class="styleClass">
		<div class="h2 title" v-html="group.TITLE" v-if="group.TITLE"></div>
    <template v-for="f in group.ITEMS">
      <template v-if="!f.GROUP_FIELD">
          <div class="form-col">
            <form-field-multiple
                v-if="Array.isArray(f.VALUE)"
                ref="field"
                :input-class="inputClass"
                :field-props="f"
                :_value="f.VALUE"
                :_type="f.TYPE"
            ></form-field-multiple>
            <form-field-email
                v-else-if="f.TYPE == 'email'"
                ref="field"
                :input-class="inputClass"
                :field-props="f"
                :value="f.VALUE"
                v-model="f.VALUE"
            ></form-field-email>
            <form-field-file
                v-else-if="f.TYPE == 'file'"
                ref="field"
                :input-class="inputClass"
                :field-props="f"
                :value="f.VALUE"
                v-model="f.VALUE"
            ></form-field-file>
            <form-field-password
                v-else-if="f.TYPE == 'password'"
                ref="field"
                :input-class="inputClass"
                :field-props="f"
                :value="f.VALUE"
                v-model="f.VALUE"
            >
              <template slot="desc">
                <slot name="password-desc"></slot>
              </template>
            </form-field-password>
            <form-field-phone
                v-else-if="f.TYPE == 'phone'"
                ref="field"
                :input-class="inputClass"
                :field-props="f"
                :value="f.VALUE"
                v-model="f.VALUE"
            ></form-field-phone>
            <form-field-textarea
                v-else-if="f.TYPE == 'textarea'"
                ref="field"
                :input-class="inputClass"
                :field-props="f"
                :value="f.VALUE"
                v-model="f.VALUE"
            ></form-field-textarea>
            <form-field-captcha
                v-else-if="f.TYPE == 'captcha'"
                ref="field"
                :input-class="inputClass"
                :field-props="f"
                :value="f.VALUE"
                v-model="f.VALUE"
            ></form-field-captcha>
            <form-field-text
            v-else
            :input-class="inputClass"
            ref="field"
            :field-props="f"
            :value="f.VALUE"
            v-model="f.VALUE"
        ></form-field-text>
          </div>
      </template>
      <form-groups v-else ref="group" :group="f" :style-class="f.CLASS" :input-class="inputClass">
        <template slot="password-desc">
          <slot name="password-desc"></slot>
        </template>
      </form-groups>
    </template>
	</div>
</template>

<script>
	export default {
		name: "FormGroups",
		props: {
			group: {
				type: [Object, Array, Boolean],
				default: function () {
					return {}
				}
			},
			styleClass: {
				type: [String, Boolean],
				default: ''
			},
			inputClass: {
				type: String,
				default: ''
			}
		},
	}
</script>
